/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_SALES_APPROVAL,
  LOAD_SALES_APPROVAL_SUCCESS,
  LOAD_SALES_APPROVAL_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(salesRecordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    salesRecordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//SalesApproval
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadSalesApproval(searchValue) {
  return {
    type: LOAD_SALES_APPROVAL,
    searchValue
  }
}

export function loadSalesApprovalSuccess(sales_details) {
  return {
    type: LOAD_SALES_APPROVAL_SUCCESS,
    sales_details,
  }
}

/**
 * @param {string} error
 */

export function loadSalesApprovalError(error) {
  return {
    type: LOAD_SALES_APPROVAL_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadSalesApproval,
  loadSalesApprovalSuccess,
  loadSalesApprovalError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
}

export default actions
